<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Últimos 50 ingresos de Bins</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" class="elevation-3 primary">Excel</v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="ingresosSearch"
                append-icon="mdi-magnify"
                label="Escriba para filtrar ingresos"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table
          :headers="waybillsListHeaders"
          :items="waybillsListBody"
          class="elevation-3 "
          no-data-text="No hay ingresos"
          :search="ingresosSearch"
          :hide-default-footer="true"
          disable-pagination
          dense
          fixed-header
          :height="table_height"
        >
          <template v-slot:[`item.numero`]="{ item }">
            <a :href="url_guias + item.url_guia" target="_blank">{{ item.numero }}</a>
          </template>
          <template slot="body.append">
            <tr class="primary--text">
              <th class="title text-center" colspan="6">Totales</th>
              <th class="title text-center">
                  {{ sumaColumna('bins') }}
              </th>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      ingresosSearch: null,
      isLoading: false,
      url_excel: '',
      table_height: 600,
      waybillsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'fecha',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patente',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Conductor',
          align: 'left',
          sortable: true,
          value: 'conductor',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Proveedor',
          align: 'left',
          sortable: true,
          value: 'proveedor',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Planta',
          align: 'left',
          sortable: true,
          value: 'planta',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Guias',
          align: 'left',
          sortable: true,
          value: 'guias',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Bins',
          align: 'right',
          sortable: true,
          value: 'bins',
          class: "salmon black--text elevation-3"
        },
      ],
      waybillsListBody: [],
    }),
    mounted() {
      this.loadBinsRomanaReport();
    },
    methods:{
      sumaColumna(key) {
        let total = 0;
        this.waybillsListBody.forEach(row => {
            total += parseInt(row[key]);
        });
        return total;
      },
      async loadBinsRomanaReport(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}reports/pesaje/last/50`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.waybillsListBody = response.data.data.report_data;
            this.url_excel = this.storage_url + response.data.data.url_excel;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      
    }
  }
</script>